/// ==================================================
/// アコーデイオン Open ではアニメーションがつけにくいのでクラス付与で
/// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  SettingsCollapse();
});
function SettingsCollapse() {
  const CollapseFlow = {
    duration: 300,
    easing: 'ease-in-out',
  };
  // アコーディオンを閉じるときのキーフレーム
  const collapseClose = (notes) => [
    {
      height: notes.offsetHeight + 'px',
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];
  // アコーディオンを開くときのキーフレーム
  const collapseOpen = (notes) => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: notes.offsetHeight + 'px',
      opacity: 1,
    },
  ];
  const detailsList = document.querySelectorAll('.js-collapse__details');
  detailsList.forEach((details) => {
    const summary = details.querySelector('.js-collapse__summary');
    const notes = details.querySelector('.js-collapse__notesArea');
    if (!summary || !notes) return;
    // -- details 全体をクリック可能にする
    summary.addEventListener('click', (event) => {
      // デフォルトの動作を防ぐ
      event.preventDefault();
      const isOpen = details.getAttribute('open') !== null;
      if (isOpen) {
        // アコーディオンを閉じるときの処理
        const closingAnim = notes.animate(collapseClose(notes), CollapseFlow);
        closingAnim.onfinish = () => {
          // アニメーションの完了後にopen属性を取り除く
          details.removeAttribute('open');
        };
      } else {
        // 開く処理
        // open属性を付与
        details.setAttribute('open', 'true');
        // アコーディオンを開くときの処理
        const openingAnim = notes.animate(collapseOpen(notes), CollapseFlow);
      }
    });
  });
}
